import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { forgotPassword } from '../services/authApi';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      await forgotPassword(email);
      setSuccess(t('auth.forgot.sent') || 'Email sent if account exists');
    } catch (err) {
      setError(err?.message || 'Failed to request reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[78px]">
      <div className="max-w-[1280px] mx-auto pt-8 sm:pt-[92px] pb-[166px] sm:pb-[100px] break-words whitespace-normal">
        <div className="px-5 text-center">
          <h2 className="text-black text-[32px] leading-[40px] sm:text-[40px] sm:leading-[50px] tracking-[-1.25px] font-normal uppercase libre-baskerville mb-4 sm:mb-5">
            {t('auth.forgot.title') || 'Forgot Password'}
          </h2>
          <p className="text-[#727272] text-[16px] leading-[20px] tracking-[-1px] font-normal">
            {t('auth.forgot.subtitle') ||
              'Enter your email to receive a reset link'}
          </p>
        </div>
        <form
          onSubmit={onSubmit}
          className="mt-10 max-w-[600px] mx-auto bg-[#F6F6F6] px-5 sm:px-[50px] py-6 sm:py-[33px] space-y-6"
        >
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.login.emailLabel') || 'Email'}
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder={
                t('auth.login.emailPlaceholder') || 'you@example.com'
              }
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
            />
          </div>
          {error ? (
            <div className="text-red-600 text-center text-sm">{error}</div>
          ) : null}
          {success ? (
            <div className="text-green-600 text-center text-sm">{success}</div>
          ) : null}
          <button
            disabled={loading}
            type="submit"
            className="bg-[#000000] w-full py-5 text-white text-[13px] leading-[14px] uppercase font-medium"
          >
            {loading
              ? t('auth.forgot.submitting') || '...'
              : t('auth.forgot.submit') || 'Send Reset Email'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
